import {
  Box,
  Button,
  ButtonBase,
  Divider,
  Grid,
  styled,
  TextField,
  Typography,
} from '@mui/material';

import { textFieldDefaultStyle } from '../../../../../components/UI/Typography';

export const NewTitleNotice = styled(Typography)(() => ({
  fontSize: '21px',
  color: '#707070',
  fontFamily: 'Montserrat',
  fontWeight: 600,
}));

export const TabContainerNotice = styled(Box)(() => ({
  padding: '18px 10px',
}));

export const AccreditationDocsSection = styled(Box)(({ theme }) => ({
  display: ' flex',
  gap: 8,
  alignItems: 'center',
  fontSize: 20,
  fontWeight: 500,
  span: {
    color: theme.palette.primary.main,
  },
}));

export const InputContainer = styled(Box)(() => ({
  gap: '16px',
  alignItems: 'center',
  marginTop: '20px',
}));

export const StyledTextFieldDefault = styled(TextField)(() => ({
  ...textFieldDefaultStyle,
}));

export const GridButton = styled(Grid)(() => ({
  display: 'flex',
  gap: '20px',
  flexDirection: 'column',
  justifyContent: 'center',
}));

export const CreateNoticeButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  fontFamily: 'Montserrat',
  gap: '10px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  color: '#FAFCFF',
  fontWeight: '600',
  height: '56px',
  backgroundColor: theme.palette.secondary.main,
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const StyledDivider = styled(Divider)(() => ({
  backgroundColor: '#D7D8DB',
  height: '1px',
  width: '100%',
  margin: '24px 0',
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  gap: '10px',
  border: `1px solid ${theme.palette.secondary.main}`,
  borderRadius: '30px',
  color: theme.palette.secondary.main,
  fontWeight: '600',
  height: '56px',
  backgroundColor: '#FAFCFF',
}));

export const ContainerGrid = styled(Grid)(() => ({
  marginTop: '40px',
  border: '1px solid #D7D8DB',
  borderRadius: '8px',
  padding: '40px',
}));

export const AddDoc = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  gap: 8,
  border: `2px solid ${theme.palette.secondary.main}`,
  borderRadius: '10px',
  padding: '10px 16px',
  color: theme.palette.secondary.main,
  fontSize: 16,
  fontWeight: 500,
  span: {
    fontWeight: 600,
    fontSize: 16,
  },
  '&:hover': {
    color: theme.palette.common.white,
    background: theme.palette.secondary.main,
  },
  '&:disabled': {
    filter: 'opacity(50%)',
  },
}));
